import React from "react";
import Background from "../assets/header.jpg";
import Navbar from "./Navbar";

function Home() {
  return (
    <div
      className="hero-background h-screen top-0 left-0 w-full bg-cover bg-center"
      style={{
        backgroundImage: `linear-gradient(to top, rgba(255, 255, 255, 0.5), rgba(255, 255, 255, 0.5)), url(${Background})`,
      }}
    >
      <div className="container">
        <Navbar />
        <header id="home" className="header">
          <div
            className="overlay absolute top-0 left-0 w-full h-full"
            style={{
              backgroundImage:
                "linear-gradient(to top, #fff 0%, rgba(105, 90, 166, 0.35) 99%, rgba(105, 90, 166, 0.5) 100%)",
            }}
          >
            <div className="flex  h-full justify-center">
              <div className=" flex flex-col items-start justify-center gap-4">
                <span className="up text-5xl sm:text-7xl text-[#3a3a3a] ">HI!</span>
                <h1 className="header-title ">
                  <span className="text-6xl sm:text-8xl text-[#313131]">I am</span>
                </h1>
                <span className="text-6xl sm:text-8xl text-[#313131]">Emirhan</span>
                <span className="text-6xl sm:text-8xl text-[#313131]">Gungor</span>
                <p className="header-subtitle text-4xl font-[100] tracking-wider text-[#313131]">
                  WEB <br></br> DEVELOPER
                </p>

                <a className="link" href="#projects">
                  <button className="btn p-4 rounded header-subtitle font-normal text-white bg-[#3e7bca] hover:bg-[#3d6caa] hover:text-gray-200 duration-300">
                    Visit My Works
                  </button>
                </a>
              </div>
            </div>
          </div>
        </header>
      </div>
    </div>
  );
}

export default Home;
